import type { TOC } from '@ember/component/template-only';
import type { SafeString } from '@ember/template';
import { PhStack, PhArchive } from 'ember-phosphor-icons';
import IconBadge from 'tio-ui/components/icon-badge';
import ConfirmationCheckIcon from 'tio-ui/components/confirmation-check-icon';
interface AnchorMessageSignature {
  Args: {
    title: string | SafeString;
    body?: string | SafeString;
    /** `check` for the animated confirmation icon, `glyph` for the all-caught-up
     * illustration, `alert` for a negative/terminal outcome (e.g. abandoned). */
    variant?: 'check' | 'glyph' | 'alert';
  };
  Element: HTMLDivElement;
}

/**
 * Informational anchor/empty-state card in the Needs Your Attention panel
 * (submitted, evidence-submitted, approved, course-cash-used, all-caught-up,
 * abandoned). No chip or CTA — these never count toward the pending-task total.
 */
const AnchorMessage: TOC<AnchorMessageSignature> = <template>
  <div
    class="tio-row tio-bg-surface
      {{if (eq @variant 'glyph') 'items-start' 'items-center'}}
      gap-3 rounded-xl border tio-border-default p-4"
    ...attributes
  >
    {{#if (eq @variant "glyph")}}
      <PhStack @size={{20}} class="tio-fg-info shrink-0" />
    {{else if (eq @variant "alert")}}
      <IconBadge @icon={{PhArchive}} @color="red" @size="md" class="shrink-0" />
    {{else}}
      <ConfirmationCheckIcon class="shrink-0" />
    {{/if}}
    <div class="min-w-0">
      <div class="tio-text-sm-semibold tio-fg-primary">{{@title}}</div>
      {{#if @body}}
        <div class="tio-text-sm-normal tio-fg-secondary mt-0.5">{{@body}}</div>
      {{/if}}
    </div>
  </div>
</template>;

export default AnchorMessage;
